import { Component } from '@theme/component';

export class ProductCarousel extends Component {
  requiredRefs = ['swiper'];

  /** @type {any} */
  #slider = null;

  connectedCallback() {
    super.connectedCallback();
    this.#initSlider();
  }

  get desktopSlides() {
    if (this.dataset.desktopSlides) {
      return Number(this.dataset.desktopSlides);
    }

    return 1.5
  }

  #initSlider() {
    this.#slider = new Swiper(this.refs.swiper, {
      allowTouchMove: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: this.desktopSlides,
        }
      }
    });
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel);
}
